var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: { title: _vm.title, icon: "ti-user" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "business-card",
        {
          staticClass: "rounded-0 h-100",
          attrs: {
            name: _vm.policyHolder.firstName + " " + _vm.policyHolder.lastName,
            relation: _vm.$t(
              "enums.relationTypes." + _vm.policyHolder.relationshipType
            ),
            email: _vm.policyHolder.email,
            imageSrc: _vm.policyHolder.avatarUuid,
            showIcon: !!_vm.policyHolder.dateOfDeath,
            dateOfDeath: _vm.policyHolder.dateOfDeath,
            variant: "noHover"
          }
        },
        [
          _c("div", { attrs: { slot: "bcFooter" }, slot: "bcFooter" }, [
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-row" },
              [
                _c("b-badge", { staticClass: "p-2 mr-2" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.policyHolder.numberOfAssignedContracts) +
                      "\n              "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getNumberOfAssignedContractsText(_vm.policyHolder)
                      ) +
                      "\n              "
                  )
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              !this.$store.getters.policyHolderContracts
                ? _c("b-card", { staticClass: "rounded-0" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.policyHolderDetails.infoText", {
                            policyHolderName: _vm.policyHolderName
                          })
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$store.getters.policyHolderContracts
                ? _c("b-card", { staticClass: "rounded-0" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.policyHolderDetails.infoText2", {
                            policyHolderName: _vm.policyHolderName
                          })
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$store.getters.policyHolderContracts
                ? _c("policy-holder-contracts")
                : _vm._e(),
              _vm._v(" "),
              !_vm.codOrCoiApproved
                ? _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c("b-col", [
                        _c("h6", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.policyHolderDetails.reportDeath",
                                { policyHolderName: _vm.policyHolderName }
                              )
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { class: [_vm.codOrCoiApproved ? "mt-4" : "mt-2"] },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "rounded-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.policyHolderDetails.certificateOfDeath"
                                )
                              ) +
                              "\n            "
                          ),
                          _vm.loadingCertificateOfDeath
                            ? _c("spinner", {
                                attrs: {
                                  size: "80",
                                  "line-size": 12,
                                  "line-fg-color": "grey",
                                  "line-bg-color": "lightgrey",
                                  speed: 1.5
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.certificateOfDeath &&
                          !_vm.loadingCertificateOfDeath
                            ? _c("b-form-file", {
                                ref: "certificateOfDeath",
                                staticClass: "rounded-0 mt-4",
                                attrs: { accept: "application/pdf, image/*" },
                                on: { change: _vm.uploadCertificateOfDeath },
                                model: {
                                  value: _vm.certificateOfDeath,
                                  callback: function($$v) {
                                    _vm.certificateOfDeath = $$v
                                  },
                                  expression: "certificateOfDeath"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _vm.certificateOfDeath &&
                                  !_vm.loadingCertificateOfDeath
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticClass:
                                            "p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",
                                          attrs: { variant: "transparent" },
                                          on: {
                                            click: _vm.printCertificateOfDeath
                                          }
                                        },
                                        [
                                          _c(
                                            "b-alert",
                                            {
                                              staticClass:
                                                "rounded-0 certificate pb-0 mb-0",
                                              attrs: {
                                                show: "",
                                                variant: "dark"
                                              }
                                            },
                                            [
                                              _c("p", [
                                                _c("span", {
                                                  staticClass: "ti-printer mr-2"
                                                }),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.policyHolderDetails.certificateOfDeathMessage"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              !_vm.codApproved
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.policyHolderDetails.certificateOfDeathEnable",
                                                              {
                                                                policyHolderName:
                                                                  _vm.policyHolderName
                                                              }
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-right" },
                                [
                                  _vm.certificateOfDeath &&
                                  !_vm.loadingCertificateOfDeath &&
                                  _vm.isCodOwner &&
                                  !_vm.codApproved
                                    ? _c(
                                        "b-btn",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName: "v-b-modal.delete_cod",
                                              modifiers: { delete_cod: true }
                                            }
                                          ],
                                          staticClass: "mt-3",
                                          attrs: { variant: "danger" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.policyHolderDetails.deleteDocument"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "rounded-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.policyHolderDetails.certificateOfInheritance"
                                )
                              ) +
                              "\n            "
                          ),
                          _vm.loadingCertificateOfInheritance
                            ? _c("spinner", {
                                attrs: {
                                  size: "80",
                                  "line-size": 12,
                                  "line-fg-color": "grey",
                                  "line-bg-color": "lightgrey",
                                  speed: 1.5
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.certificateOfInheritance &&
                          !_vm.loadingCertificateOfInheritance
                            ? _c("b-form-file", {
                                ref: "certificateOfInheritance",
                                staticClass: "rounded-0 mt-4",
                                attrs: { accept: "application/pdf" },
                                on: {
                                  change: _vm.uploadCertificateOfInheritance
                                },
                                model: {
                                  value: _vm.certificateOfInheritance,
                                  callback: function($$v) {
                                    _vm.certificateOfInheritance = $$v
                                  },
                                  expression: "certificateOfInheritance"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _vm.certificateOfInheritance &&
                                  !_vm.loadingCertificateOfInheritance
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticClass:
                                            "p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",
                                          attrs: { variant: "transparent" },
                                          on: {
                                            click:
                                              _vm.printCertificateOfInheritance
                                          }
                                        },
                                        [
                                          _c(
                                            "b-alert",
                                            {
                                              staticClass:
                                                "rounded-0 certificate pb-0 mb-0",
                                              attrs: {
                                                show: "",
                                                variant: "dark"
                                              }
                                            },
                                            [
                                              _c("p", [
                                                _c("span", {
                                                  staticClass: "ti-printer mr-2"
                                                }),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.policyHolderDetails.certificateOfInheritanceMessage"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              !_vm.coiApproved
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.policyHolderDetails.certificateOfInheritanceEnable",
                                                              {
                                                                policyHolderName:
                                                                  _vm.policyHolderName
                                                              }
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-right" },
                                [
                                  _vm.certificateOfInheritance &&
                                  !_vm.loadingCertificateOfInheritance &&
                                  !_vm.coiApproved
                                    ? _c(
                                        "b-btn",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName: "v-b-modal.delete_coi",
                                              modifiers: { delete_coi: true }
                                            }
                                          ],
                                          staticClass: "mt-3",
                                          attrs: { variant: "danger" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.policyHolderDetails.deleteDocument"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete_cod",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.policyHolderDetails.modal.title"),
            "ok-title": _vm.$t("message.policyHolderDetails.modal.ok"),
            "cancel-title": _vm.$t("message.policyHolderDetails.modal.cancel")
          },
          on: { ok: _vm.deleteCertificateOfDeath }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.policyHolderDetails.modal.message")))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete_coi",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.policyHolderDetails.modal.title"),
            "ok-title": _vm.$t("message.policyHolderDetails.modal.ok"),
            "cancel-title": _vm.$t("message.policyHolderDetails.modal.cancel")
          },
          on: { ok: _vm.deleteCertificateOfInheritance }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.policyHolderDetails.modal.message")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3316bf23", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3316bf23","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/policyholder/PolicyHolderDetails.vue
// module id = OMKt
// module chunks = 1